import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "~/foundation/i18n";
import { cn } from "~/foundation/utils/cn";

export function Language() {
  const { t, i18n } = useTranslation();
  const current = i18n.resolvedLanguage ?? i18n.language;

  return (
    <fieldset className="flex flex-col gap-1">
      <legend className="sr-only">{t("Language")}</legend>
      {SUPPORTED_LANGUAGES.map((language) => (
        <label
          key={language.code}
          className={cn(
            "flex cursor-pointer items-center gap-3 rounded-sm border px-3 py-2",
            current === language.code ? "border-accent" : "border-divider hover:bg-hover-bg",
          )}
        >
          <input
            type="radio"
            name="language"
            value={language.code}
            checked={current === language.code}
            onChange={() => void i18n.changeLanguage(language.code)}
            className="accent-[var(--accent)]"
          />
          <span className="flex-1 text-body text-text">{language.label}</span>
          <span className="text-small text-text-tertiary uppercase">{language.dir}</span>
        </label>
      ))}
    </fieldset>
  );
}
